import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";

const uploadDropZoneTemporary = async (token, bytes, filename, prefix) => {
  try {
    const url = prefix + "upload/dropzone-temporary";
    // Create a new FormData object
    const formData = new FormData();

    formData.append("file", new Blob([bytes]), filename);

    const token = await getOrRefreshFirebaseToken();

    // Send the request with the file and token
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (response.ok) {
      // Read the response body as JSON
      const jsonResponse = await response.json();
      const data = jsonResponse.data;

      const url = data.url;
      const name = data.name;

      return { url, name };

      // Trigger the onDrop callback with the URL and name
    } else {
      console.error(`Error response for file ${filename}: ${response.status}`);
    }
  } catch (error) {
    console.error("Error selecting/uploading files:", error);
  }
};

export default uploadDropZoneTemporary;
